var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJapanFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_672)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44_672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-14.2412 2.6893H94.6645V76.6902H-14.2412V2.6893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2118 60.5014C51.4894 60.5014 60.6316 51.1833 60.6316 39.6889C60.6316 28.1944 51.4894 18.8763 40.2118 18.8763C28.9343 18.8763 19.792 28.1944 19.792 39.6889C19.792 51.1833 28.9343 60.5014 40.2118 60.5014Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -13.7412,
    y: 3.19006,
    width: 107.906,
    height: 73,
    stroke: "#C4C4C4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_672"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44_672"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.2412,
    y: 2.69006,
    width: 108.906,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapanFlag);
export default __webpack_public_path__ + "static/media/japan-flag.6d74af5197bc36a95b5b56db742974f2.svg";
export { ForwardRef as ReactComponent };